import { create } from 'zustand';

const tokensStore = create(set => ({
  userTokens: [],
  xbrPrice: 0,
  tbaPrice: 0,
  usdtPrice: 0,
  usdcPrice: 0,

  setUserTokens: userTokens => set({ userTokens }),
  setXbrPrice: xbrPrice => set({ xbrPrice }),
  setTbaPrice: tbaPrice => set({ tbaPrice }),
  setUsdtPrice: usdtPrice => set({ usdtPrice }),
  setUsdcPrice: usdcPrice => set({ usdcPrice }),
}));

export const useTokensStore = tokensStore;
